export const CARD_BINDING_PROVIDER_LABELS = {
  paydibs: "Paydibs",
};

export const CARD_NETWORK_LABELS = {
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "Amex",
  jcb: "JCB",
  unionpay: "UnionPay",
  diners: "Diners",
};

export const CARD_CHARGE_STATUSES = ["PENDING", "SUCCESS", "FAILED"];

export const CARD_CHARGE_STATUS_COLORS = {
  PENDING: "gold",
  SUCCESS: "green",
  FAILED: "red",
};

// Mirrors the API's charge validation: 0.01 to 10000, at most 2 decimals, reason up to 500 chars
export const CARD_CHARGE_MIN_AMOUNT = 0.01;
export const CARD_CHARGE_MAX_AMOUNT = 10000;
export const CARD_CHARGE_REASON_MAX_LENGTH = 500;

export const CARD_HISTORY_PAGE_SIZE = 5;
export const CARD_CHARGE_PAGE_SIZE = 50;
